export default "/_next/static/images/7b/5-7b1d42a6922b50e27eb6ee8b12ea6c36.jpg";